import React from "react";
import CryptoJS from "crypto-js";

 // Replace with an environment variable in production
export const getQueryParams = (params, url) => {
  let href = url;
  //this expression is to get the query strings
  let reg = new RegExp('[?&]' + params + '=([^&#]*)', 'i');
  let queryString = reg.exec(href);
  return queryString ? queryString[1] : null;
};

export const maskNumber = (phone) => {
  var maskedNumber = phone.replace(/\d(?=\d{2})/g, "X");
  return maskedNumber;
};

export const getToken = () => {
  try {
    const lsVal = localStorage.getItem("token");
    if (lsVal) return lsVal;
  } catch (e) {}
  return getCookie("token");
}

export const getApiKey = () => {
  try {
    const lsVal = localStorage.getItem("apiKey");
    if (lsVal) return lsVal;
  } catch (e) {}
  return getCookie("apiKey");
}

export const getTeamEmail = () => {
  try {
    const lsVal = localStorage.getItem("teamEmail");
    if (lsVal) return lsVal;
  } catch (e) {}
  return getCookie("teamEmail");
}

export const setToken = (token) => {
  try {
    localStorage.setItem("token", token);
  } catch (e) {}
  try {
    setCookie("token", token, 1);
  } catch (e) {}
  return true;
}

export const setApiKey = (apiKey) => {
  try {
    localStorage.setItem("apiKey", apiKey);
  } catch (e) {}
  try {
    setCookie("apiKey", apiKey, 1);
  } catch (e) {}
  return true;
}

export const setTeamEmail = (teamEmail) => {
  try {
    localStorage.setItem("teamEmail", teamEmail);
  } catch (e) {}
  try {
    setCookie("teamEmail", teamEmail, 1);
  } catch (e) {}
  return true;
}

export const removeToken = () => {
  try {
    localStorage.removeItem("token");
  } catch (e) {}
  try {
    setCookie("token", "", -1);
  } catch (e) {}
  return true;
}

export const removeApiKey = () => {
  try {
    localStorage.removeItem("apiKey");
  } catch (e) {}
  try {
    setCookie("apiKey", "", -1);
  } catch (e) {}
  return true;
}

export const removeTeamEmail = () => {
  try {
    localStorage.removeItem("teamEmail");
  } catch (e) {}
  try {
    setCookie("teamEmail", "", -1);
  } catch (e) {}
  return true;
}

export const getUser = () => {
  try {
    const lsVal = localStorage.getItem("user");
    if (lsVal) {
      try { return JSON.parse(lsVal); } catch (_) { return lsVal; }
    }
  } catch (e) {}
  return getCookie("user", true);
}

export const setUser = (userObj) => {
  try {
    localStorage.setItem("user", typeof userObj === "string" ? userObj : JSON.stringify(userObj));
  } catch (e) {}
  try {
    setCookie("user", userObj, 1, true);
  } catch (e) {}
  return true;
}

export const removeUser = () => {
  try {
    localStorage.removeItem("user");
  } catch (e) {}
  try {
    setCookie("user", "", -1);
  } catch (e) {}
  return true;
}

export const getProfile = () => {
  try {
    const user = getUser();
    console.log("user",user)
    if (!user) return null;
    if (typeof user === 'string') {
      try { return JSON.parse(user); } catch (_) { return null; }
    }
    return user.profile || user;
  } catch (e) {
    return null;
  }
};

export const can = (permissionKey) => {
  try {
    
    const profile = getProfile();
    console.log("profile",profile)
    if (!profile) return false;
    if (profile.role === 'owner') return true;
    const perms = profile.permissions || {};
    const custom = perms.customPermissions || {};
    if (typeof custom[permissionKey] === 'boolean') return custom[permissionKey];
    const action = perms.actionPermissions || {};
    if (typeof action[permissionKey] === 'boolean') return action[permissionKey];
    return false;
  } catch (e) {
    return false;
  }
};

export const hasPage = (pageKey) => {
  try {
    const profile = getProfile();
    if (!profile) return false;
    if (profile.role === 'owner') return true;
    const allowed = (profile.permissions?.allowedPages || []).map(p => String(p).toLowerCase());
    return allowed.includes(String(pageKey).toLowerCase());
  } catch (e) {
    return false;
  }
};

export const copyToClipboard = (str, element) => {
  const el = document.createElement('textarea');
  el.value = str;
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
  if (element) {
    const originalText = element.textContent;
    element.textContent = originalText +' Copied!';
    setTimeout(() => {
      element.textContent = originalText;
    }, 2000); // 2 seconds delay
  }
};

export const getProduct = () => {
  return 1;
}

export function setCookie(cname, cvalue, exdays,object=false) {
  var d = new Date();
  if(object) cvalue = JSON.stringify(cvalue);
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var isSecure = window.location.protocol === 'https:';
  var sameSiteSecure = isSecure ? 'SameSite=None;Secure;' : 'SameSite=Lax;';

  var InExpires = "domain=.betyphon.in;expires=" + d.toUTCString();
  var ComExpires = "domain=.betyphon.com;expires=" + d.toUTCString();
  var LocalExpires = "domain=localhost;expires=" + d.toUTCString();

  document.cookie = cname + "=" + cvalue + ";" + InExpires + ";path=/;" + sameSiteSecure;
  document.cookie = cname + "=" + cvalue + ";" + ComExpires + ";path=/;" + sameSiteSecure;
  document.cookie = cname + "=" + cvalue + ";" + LocalExpires + ";path=/;" + (isSecure ? sameSiteSecure : 'SameSite=Lax;');
}



export function getCookie(cname,object=false) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);

  var ca = decodedCookie.split(';');
  //console.log("coooo",ca)
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export const formatFieldValue = (value) => {
  if (value === null || value === undefined || value === "") return ""; // Handle null, undefined, or empty values
  
  // Check for Boolean values
  if (typeof value === "boolean") {
    return value ? "Yes" : "No"; // Return "Yes" for true, "No" for false
  }

  // Check for strictly numeric strings or numbers
  if (!isNaN(value) && !isValidDateTime(value)) {
    return parseInt(value, 10); // Convert to integer
  }

  // Check for DateTime
  if (isValidDateTime(value)) {
    return new Date(value).toLocaleString(); // Format as datetime
  }

  // Check for Email
  if (isValidEmail(value)) {
    //return <a href={`mailto:${value}`}>{value}</a>; // Hyperlink email
    return value; // Hyperlink email
  }

  // Check for URL
  if (isValidURL(value)) {
    return <a href={value} target="_blank" rel="noopener noreferrer">{value}</a>; // Hyperlink URL
  }

  // Check for Phone Number
  if (isValidPhoneNumber(value)) {
    return <a href={`tel:${value}`}>{value}</a>; // Hyperlink phone number
  }

  // Default: Return the value as-is
  return value;
};

// Validation helper methods
const isValidDateTime = (value) => {
  if (typeof value !== "string") return false; // Ensure the value is a string

  // Regex to match common date formats: YYYY-MM-DD, YYYY/MM/DD, and ISO format
  const dateRegex = /^\d{4}[-/]\d{2}[-/]\d{2}(T\d{2}:\d{2}(:\d{2}(\.\d{1,3})?)?(Z|([+-]\d{2}:\d{2})))?$/;

  if (!dateRegex.test(value)) {
    return false; // Invalid date format
  }

  const date = new Date(value);
  return !isNaN(date.getTime()); // Check if the parsed date is valid
};

const isValidEmail = (value) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Simple email regex
  return emailRegex.test(value);
};

const isValidURL = (value) => {
  try {
    new URL(value); // Will throw an error if invalid
    return true;
  } catch {
    return false;
  }
};

const isValidPhoneNumber = (value) => {
  const phoneRegex = /^\+?[1-9]\d{1,14}$/; // E.164 international phone number format
  return phoneRegex.test(value);
};

const SECRET_KEY = "my-secure-key"; // Replace with an environment variable in production

// Encrypt data
export const encryptData = (data) => {
  return CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
};

// Decrypt data
export const decryptData = (encryptedData) => {
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  } catch (error) {
    console.error("Error decrypting data:", error);
    return null;
  }
};

export const replacePlaceholdersInString = (str, values) => {
    return str.replace(/{{(.*?)}}/g, (_, key) => {
      return values[key] !== undefined ? values[key] : `{{${key}}}`; // Replace with value or keep as placeholder if not found
    });
  }

export const cacheUtil = {
  set: (key, data, ttl = 60 * 1000) => {
    const cacheData = {
      value: data,
      expiry: Date.now() + ttl,
    };
    sessionStorage.setItem(key, encryptData(cacheData));
  },

  get: (key) => {
    const encryptedItem = sessionStorage.getItem(key);
    if (!encryptedItem) return null;

    const decryptedData = decryptData(encryptedItem);
    if (!decryptedData) return null;

    // Check if expired
    if (Date.now() > decryptedData.expiry) {
      sessionStorage.removeItem(key);
      return null;
    }

    return decryptedData.value;
  },

  remove: (key) => {
    sessionStorage.removeItem(key);
  },
};

export const isMobile = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return /android|iPad|iPhone|iPod/i.test(userAgent);
};
  
export const formatDate = (dateString) => {
  if (!dateString) {
    return 'N/A'; // Or any other placeholder for missing dates
  }
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString(); // Use toLocaleDateString for user-friendly format
  } catch (error) {
    console.error("Error formatting date:", dateString, error);
    return 'Invalid Date'; // Handle invalid date strings
  }
};



  /**
   * Returns a Date object from a given date string, or null if invalid.
   * This is used to format dates for form submission.
   * @param {string} dateString - The date string to format
   * @returns {Date|null} Formatted Date object or null if invalid
   * @example
   * formatDateForForm("2022-01-01") // Returns a Date object for Jan 1, 2022
   * formatDateForForm("2022-01-01T12:00:00.000Z") // Returns a Date object for Jan 1, 2022, 12:00:00 UTC
   * formatDateForForm("Invalid Date") // Returns null
   */
export const formatDateForForm = (dateString) => {
  if (!dateString) {
      return null;
  }
  try {
      return new Date(dateString);
  } catch (error) {
      console.error("Error formatting date for form:", dateString, error);
      return null; // Or handle the error as appropriate for your application
  }
};

export const setAutoAuthPending = (value) => {
  try {
    if (value) {
      sessionStorage.setItem('autoAuthPending', '1');
    } else {
      sessionStorage.removeItem('autoAuthPending');
    }
  } catch (e) {}
};

export const isAutoAuthPending = () => {
  try {
    return sessionStorage.getItem('autoAuthPending') === '1';
  } catch (e) {
    return false;
  }
};

